import { JobInterview } from "src/types";
import DocPdf from "src/components/S3/DocPdf";
import { ReactComponent as NoFile } from "src/assets/svg/no-file.svg";
import { useAppSelector } from "src/redux/store";
import ConstraintModal from "src/components/Modal/ConstraintModal";
import { useSearchParams } from "react-router-dom";
import { tab } from "..";

const Resume = ({ interview }: { interview: JobInterview }) => {
  const [, setSearchParam] = useSearchParams();
  const enabled = useAppSelector(
    (r) => !!r.client?.client?.Company?.UsageConstraints?.resume_enabled
  );
  const { resume_presigned, resume } = interview;
  if (!resume_presigned || !resume)
    return (
      <div className="mx-auto flex flex-col items-center gap-6 pt-[120px]">
        <NoFile className="w-[220px] h-[220px]" />
        <p className="font-poppins text-xl font-semibold">No Resume Found</p>

        <ConstraintModal
          variant="resume_enabled"
          open={!enabled}
          onClose={() => setSearchParam(`tab=${"Report" as tab}`)}
        />
      </div>
    );
  return <DocPdf resume={resume_presigned} />;
};

export default Resume;
